/**
 * Telemetry utility for sending user engagement events
 * All functions are designed to fail silently - telemetry should never affect user experience
 */

/**
 * Send a generic telemetry event to the backend
 * @param {string} eventName - Name of the event
 * @param {string} userEmail - User's email address
 * @param {Object} properties - Additional event properties
 */
export const trackEvent = async (eventName, userEmail, properties = {}) => {
  try {
    const enrichedProperties = {
      ...properties,
      timestamp: new Date().toISOString(),
      screenWidth: typeof window !== 'undefined' ? window.innerWidth.toString() : 'unknown',
    };

    await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/telemetry/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        eventName,
        userEmail: userEmail || 'unknown',
        properties: enrichedProperties,
      }),
    });
  } catch (e) {
    // Silently fail - telemetry should never affect user experience
    console.debug('[Telemetry] Failed to send event:', eventName, e.message);
  }
};

/**
 * Track when a user toggles between Classic and Split views
 * @param {string} userEmail - User's email address
 * @param {string} fromView - The view being switched from ('classic' or 'split')
 * @param {string} toView - The view being switched to ('classic' or 'split')
 */
export const trackViewToggle = (userEmail, fromView, toView) => {
  trackEvent('ViewToggle', userEmail, { fromView, toView });
};

/**
 * Track when the dashboard loads after authentication
 * @param {string} userEmail - User's email address
 * @param {string} viewType - Current view type ('classic' or 'split')
 */
export const trackDashboardLoad = (userEmail, viewType) => {
  trackEvent('DashboardLoad', userEmail, { viewType });
};
